import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUser, postUser } from "./userApi";
import { updateUserApi } from "./userApi";

export const getUserRequest = createAsyncThunk(
  "getUserRequest/user",
  async () => {
    try {
      const response = await getUser();
      return response;
    } catch (error) {}
  }
);

export const postUserRequest = createAsyncThunk(
  "postUserRequest/user",
  async (payload: any) => {
    try {
      const response = await postUser(payload);
      return response;
    } catch (error) {}
  }
);

export const updateUserRequest = createAsyncThunk(
  "updateUserRequest/user",
  async (payload: any) => {
    try {
      const response = await updateUserApi(payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
);

interface IInitialState {
  postUser: any;
  userLIst: any;
  message: string;
  pageIsLoading: boolean;
  userUpdate: any;
  isSuccess: boolean;
}

const initialState: IInitialState = {
  postUser: {},
  userLIst: [],
  userUpdate: {},
  message: "",
  pageIsLoading: false,
  isSuccess: false,
};

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    resetUserMessage: (state) => {
      state.message = "";
    },
    resetSuccessUser: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getUserRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.userLIst = action.payload.data;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getUserRequest.rejected, (state) => {
      state.message = "get user failed";
      state.pageIsLoading = false;
    });

    // post builder
    builder.addCase(postUserRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(postUserRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.message = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.postUser = action.payload.data;
        state.message = "success";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(postUserRequest.rejected, (state) => {
      state.message = "get user failed";
      state.pageIsLoading = false;
    });

    // update user reducer
    builder.addCase(updateUserRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateUserRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.userUpdate = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else if (action.payload.status === 2000) {
        state.message = "Employe ID is Required";
        state.pageIsLoading = false;
      } else {
        state.message = "Someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateUserRequest.rejected, (state) => {
      state.message = "Someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetUserMessage, resetSuccessUser } = userSlice.actions;
export default userSlice.reducer;
